export class ProposalProjectSavingsStaff{
    constructor(id, proposalProject, jobPosition, numberOfPeople, quantity, period, type, origin){
        this.id = id;
        this.proposalProject = proposalProject;
        this.jobPosition = jobPosition;
        this.numberOfPeople = numberOfPeople;
        this.quantity = quantity;
        this.period = period;
        this.type = type;
        this.origin = origin;
    }
    static createFromResponseData(responseData){
        return new ProposalProjectSavingsStaff(
            responseData.id,
            responseData.proposalProject,
            responseData.jobPosition,
            responseData.numberOfPeople,
            responseData.quantity,
            responseData.period,
            responseData.type,
            responseData.origin
        );
    }
};